(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbf-article-premium"]) return;
  try {
    
  function harmonizeLegacyBlogArticles(root = document) {
    root.querySelectorAll('.lbf-article__body--legacy details').forEach((details) => {
      details.open = true;
    });

    root.querySelectorAll('.lbf-article__body--legacy h2, .lbf-article__body--legacy p').forEach((element) => {
      const text = element.textContent.replace(/\u00a0/g, ' ').trim();
      const hasMedia = element.querySelector('img, video, iframe, svg');

      if (!text && !hasMedia) {
        element.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => harmonizeLegacyBlogArticles(), { once: true });
  } else {
    harmonizeLegacyBlogArticles();
  }

  document.addEventListener('shopify:section:load', (event) => {
    harmonizeLegacyBlogArticles(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
